
<div class="portrait-prompt-panel">
  <div class="portrait-prompt-panel-component hidden">
    <div class="component-background" @click="close" />
    <slide-y-down-transition :duration="1000">
      <div
        v-show="show"
        class="wrapper"
        :class="$store.state.theme"
        @click="close"
      >
        <div class="close">
          <button class="delete is-large" @click="close" />
        </div>
        <p style="margin-bottom: 10px">
          <img src="/img/home2/edit-tools.svg" />
        </p>
        <p class="is-size-5">{{ $t("view-in-portrait") }}</p>
        <br />
        <span class="button is-warning is-rounded" @click="close">
          {{ this.$t("okay") }}
        </span>
      </div>
    </slide-y-down-transition>
  </div>
</div>
